import { fetchJsonWithAuthJWTToken } from "ra-data-django-rest-framework"

import endpoints from "api/endpoints"

class CoursesAPI {
  mailoutEmails(id, state) {
    const searchParams = new URLSearchParams()
    searchParams.append("state", state)
    return fetchJsonWithAuthJWTToken(
      endpoints.courseMailoutEmails(id) + `?${searchParams.toString()}`
    ).then(({ json }) => json)
  }

  sendMailout(id, data) {
    return fetchJsonWithAuthJWTToken(endpoints.sendCourseMailout(id), {
      method: "post",
      body: JSON.stringify(data),
    }).then(({ json }) => json)
  }

  list() {
    return fetchJsonWithAuthJWTToken(
      `${endpoints.coursesList()}?page_size=100`
    ).then(({ json }) => json)
  }
}

export default new CoursesAPI()
